export type SeenTourStatus = 'completed' | 'dismissed'
export type SeenTourScope = 'user' | 'workspace'
type SeenTours = Record<string, { status: SeenTourStatus; seenAt: string }>

const storageKey = (userId: string, workspaceId: string, scope: SeenTourScope = 'workspace') =>
  scope === 'user'
    ? `timelining:seen-tours:${userId}:*`
    : `timelining:seen-tours:${userId}:${workspaceId}`

const readSeenTours = (userId: string, workspaceId: string, scope: SeenTourScope = 'workspace'): SeenTours => {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(storageKey(userId, workspaceId, scope)) ?? '{}')
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed as SeenTours : {}
  } catch {
    return {}
  }
}

export const hasSeenTour = (tourId: string, userId: string, workspaceId: string, scope: SeenTourScope = 'workspace'): boolean =>
  Boolean(readSeenTours(userId, workspaceId, scope)[tourId])

export const markTourSeen = (tourId: string, status: SeenTourStatus, userId: string, workspaceId: string, scope: SeenTourScope = 'workspace'): void => {
  // localStorage.setItem can throw QuotaExceededError (Safari incognito with
  // cookies blocked, full storage on certain mobile browsers); we don't want
  // that to abort the surrounding endTour/skipTour cleanup. Best-effort.
  try {
    const tours = readSeenTours(userId, workspaceId, scope)
    tours[tourId] = { status, seenAt: new Date().toISOString() }
    window.localStorage.setItem(storageKey(userId, workspaceId, scope), JSON.stringify(tours))
  } catch (error) {
    console.warn('[TOURGUIDE] Could not persist tour-seen state.', error)
  }
}
